const PaginationSkeleton = () => {
  return <div className='mx-auto mt-4 h-6 w-64 animate-pulse rounded bg-gray-100 lg:mt-6 lg:h-8 lg:w-full' data-sentry-component="PaginationSkeleton" data-sentry-source-file="pagination-skeleton.tsx" />;
};
export default PaginationSkeleton;